import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { countrySwitch, skipSet } from '../../store/filterSlice';
import { useTranslation } from 'react-i18next';
import useApiGet from '../../hooks/useApiGet';
import ListSwitch from './ListSwitch';
import { getCountryName } from '../../utils/countries';
import { SHORT_LIST_LENGTH } from './FilterCategoryList';
//
// Вспомогательный компонент для отображения фильтра по странам участников мероприятия
//
const FilterCountry = ({ event }) => {
    const { t, i18n } = useTranslation();
    const lang = i18n.language;
    const dispatch = useDispatch();
    const filter = useSelector(state => state.filter);
    const [ display, setDisplay ] = useState(false);
    const [ listClass, setListClass ] = useState('list-open');
	const [ method, setMethod ] = useState(`/countries/${event._id}`);
    // eslint-disable-next-line
    const [ data, error, isLoading ] = useApiGet({ method });
    const [ longList, setLongList ] = useState([]);
    const [ showList, setShowList ] = useState([]);

    // При смене мероприятия, надо обновить список
    useEffect(() => {
        setMethod(`/countries/${event._id}`);
    }, [ event ]);

    // Посчитываем общее число экспонентов по странам
    // чтобы узнать надо ли вообще показывать список.
    // Не учитываем участников, которые не указали страну.
    useEffect(() => {
        setDisplay(false);
        setLongList([]);
        setShowList([]);

        if(!data || !Array.isArray(data.countries) || data.countries.length < 1) return;

        let count = 0;
        let longList = [];
        data.countries.forEach(item => {
            if(item.alpha3) {
                count += item.count;
                longList.push(item);
            }
        });
        if(!count) return;

        setLongList(longList);
        setShowList(longList.slice(0, SHORT_LIST_LENGTH));
        setDisplay(true);
    }, [ data ]);

    const onSwitch = (alpha3) => {
        dispatch(countrySwitch(alpha3));
        dispatch(skipSet(0));
    };

    // Переключаем отображения всего списка или его краткого варианта
    const onSwitchList = () => {
        if(showList.length === longList.length) {
            setShowList(longList.slice(0, SHORT_LIST_LENGTH));
        } else {
            setShowList(longList);
        }
    };

    // В странах нет участников, поэтому их показывать не надо
    if(!display) return null;

    return (            
        <React.Fragment>
        <ListSwitch title='filter.geography' setListClass={setListClass} border={false}/>
        <div className={listClass}>
        {showList.map(country => (
            <div
                key={country.alpha3 ?? 'null'}
                onClick={() => onSwitch(country.alpha3)}
                className={filter.countries.indexOf(country.alpha3) < 0 ? 'item' : 'item check'}
            >
                <span className='icon'>
                    <FontAwesomeIcon
                        icon={filter.countries.indexOf(country.alpha3) < 0 ? faSquare : faSquareCheck}
                    />
                </span>
                <div className='text'>
                    {getCountryName(country.alpha3, lang)}&nbsp;
                    <small style={{color:'var(--gray-color)'}}>
                        ({country.count})
                    </small>
                </div>
            </div>)
        )}        
        {longList.length > SHORT_LIST_LENGTH && <div className='right'>
            <span className='small a' onClick={() => onSwitchList()}>
                {showList.length === longList.length ? t('common.less') : t('common.more')}
            </span>
        </div>}
        </div>
        </React.Fragment>
    );
};

export default FilterCountry;
